import { all, fork, put, takeEvery, call } from 'redux-saga/effects';
import { SagaIterator } from '@redux-saga/core';

// apicore
import { APICore } from '../../helpers/api/apiCore';

// helpers
import { addRebate_Api, updRebate_Api, addRebatePaid_Api, updRebatePaid_Api } from '../../helpers';

// actions
import { debateApiResponseSuccess, debateApiResponseError } from './actions';

// constants
import { DebateActionTypes } from './constants';

type debitCredit_type = {
    payload: {
        id: string;
        accountid: string;
        entrydate: string;
        description: string;
        totalamount: string;
        reference: string;
        cashcounterid: string;
        cashreceived: string;
        cashpaid: string;
        bankid: string;
        bankpaid: string;
        bankreceived: string;
        transtype:string;
        voucherdetdata: [];
    };
    type: string;
};
const api = new APICore();
function* addDebateReceived({
    payload: {
        entrydate,
        accountid,
        description,
        totalamount,
        reference,
        cashcounterid,
        cashreceived,
        bankid,
        bankreceived,
        transtype,
        voucherdetdata,
    },
}: debitCredit_type): SagaIterator {
    try {
        const response = yield call(addRebate_Api, {
            entrydate,
            accountid,
            description,
            totalamount,
            reference,
            cashcounterid,
            cashreceived,
            bankid,
            bankreceived,
            transtype,
            voucherdetdata,
        });
        const item = response.data;
        yield put(debateApiResponseSuccess(DebateActionTypes.REBATE_RECEVIED, item));
    } catch (error: any) {
        yield put(debateApiResponseError(DebateActionTypes.REBATE_RECEVIED, error));
    }
}

function* addDebatePaid({
    payload: {
        entrydate,
        accountid,
        description,
        totalamount,
        reference,
        cashcounterid,
        cashpaid,
        bankid,
        bankpaid,
        transtype,
        voucherdetdata,
    },
}: debitCredit_type): SagaIterator {
    try {
        const response = yield call(addRebatePaid_Api, {
            entrydate,
            accountid,
            description,
            totalamount,
            reference,
            cashcounterid,
            cashpaid,
            bankid,
            bankpaid,
            transtype,
            voucherdetdata,
        });
        const item = response.data;
        yield put(debateApiResponseSuccess(DebateActionTypes.REBATE_PAID, item));
    } catch (error: any) {
        yield put(debateApiResponseError(DebateActionTypes.REBATE_PAID, error));
    }
}

function* updDebateReceived({
    payload: {
        id,
        entrydate,
        accountid,
        description,
        totalamount,
        reference,
        cashcounterid,
        cashreceived,
        bankid,
        bankreceived,
        transtype,
        voucherdetdata,
    },
}: debitCredit_type): SagaIterator {
    try {
        const response = yield call(updRebate_Api, {
            id,
            entrydate,
            accountid,
            description,
            totalamount,
            reference,
            cashcounterid,
            cashreceived,
            bankid,
            bankreceived,
            transtype,
            voucherdetdata,
        });
        const item = response.data;
        yield put(debateApiResponseSuccess(DebateActionTypes.UPDREBATE_RECEVIED, item));
    } catch (error: any) {
        yield put(debateApiResponseError(DebateActionTypes.UPDREBATE_RECEVIED, error));
    }
}
function* updDebatePaid({
    payload: {
        id,
        entrydate,
        accountid,
        description,
        totalamount,
        reference,
        cashcounterid,
        cashpaid,
        bankid,
        bankpaid,
        transtype,
        voucherdetdata,
    },
}: debitCredit_type): SagaIterator {
    try {
        const response = yield call(updRebatePaid_Api, {
            id,
            entrydate,
            accountid,
            description,
            totalamount,
            reference,
            cashcounterid,
            cashpaid,
            bankid,
            bankpaid,
            transtype,
            voucherdetdata,
        });
        const item = response.data;
        yield put(debateApiResponseSuccess(DebateActionTypes.UPD_REBATE_PAID, item));
    } catch (error: any) {
        yield put(debateApiResponseError(DebateActionTypes.UPD_REBATE_PAID, error));
    }
}
export function* watchAdd(): any {
    yield takeEvery(DebateActionTypes.REBATE_RECEVIED, addDebateReceived);
    yield takeEvery(DebateActionTypes.UPDREBATE_RECEVIED, updDebateReceived);
    yield takeEvery(DebateActionTypes.REBATE_PAID, addDebatePaid);
    yield takeEvery(DebateActionTypes.UPD_REBATE_PAID, updDebatePaid);
    // yield takeEvery(PurchaseActionTypes.SUPP_DEBIT_NOTE, addDebitNote);
    // yield takeEvery(PurchaseActionTypes.SUPP_UPD_DEBIT, updDebitNote);
    // yield takeEvery(PurchaseActionTypes.SUPP_CREDIT_NOTE, addCreditNote);
    // yield takeEvery(PurchaseActionTypes.SUPP_UPD_CREDIT_NOTE, updCreditNote);
    // yield takeEvery(PurchaseActionTypes.ADD_SERVICE_BILL, addServiceBill);
    // yield takeEvery(PurchaseActionTypes.ADD_PURCHASEINV, addPurchase);
    // yield takeEvery(PurchaseActionTypes.UPD_PURCHASEINV, updPurchase);
    // yield takeEvery(PurchaseActionTypes.ADD_PURCHASE_RETURN, addPurchaseReturn);
    // yield takeEvery(PurchaseActionTypes.UPD_PURCHASE_RETURN, updPurchaseReturn);
    // yield takeEvery(PurchaseActionTypes.SUPPLIER_PAYMENT, addVenPay);
    // yield takeEvery(PurchaseActionTypes.UPD_SUPPLIER_PAYMENT, updVenPay);
}

function* purchaseSaga() {
    yield all([fork(watchAdd)]);
}

export default purchaseSaga;
